interface HeroSectionProps {
  onOpenModal: () => void;
}

export default function HeroSection({ onOpenModal }: HeroSectionProps) {
  const scrollToServices = () => {
    document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=luxurious%20modern%20premium%20dental%20clinic%20interior%20bright%20reception%20area%20elegant%20blue%20white%20color%20scheme%20professional%20dental%20office%20high%20end%20sophisticated%20architectural%20design%20soft%20warm%20lighting&width=1920&height=1080&seq=mfdentalhero001&orientation=landscape"
          alt="MF Dental clínica premium Ciudad de México"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A2540]/88 via-[#0A2540]/75 to-[#071a2e]/92" />
        {/* Decorative glow */}
        <div className="absolute top-1/3 left-1/4 w-96 h-96 bg-[#3A86FF]/15 rounded-full blur-[120px]" />
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-[#3A86FF]/10 rounded-full blur-[80px]" />
      </div>

      {/* Main content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 text-center pt-24">
        {/* Rating badge */}
        <div className="inline-flex items-center gap-2 glass rounded-full px-5 py-2.5 mb-10 animate-fadeUp">
          <div className="flex gap-0.5 w-auto h-auto items-center justify-center">
            {[...Array(5)].map((_, i) => (
              <i key={i} className="ri-star-fill text-yellow-400 text-sm" />
            ))}
          </div>
          <span className="text-white font-semibold text-sm">5.0</span>
          <span className="text-white/40 mx-1">|</span>
          <span className="text-white/75 text-sm">15 opiniones verificadas</span>
        </div>

        {/* Title */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.1] mb-6 animate-fadeUp">
          Transformamos tu sonrisa
          <span className="block mt-2 bg-gradient-to-r from-[#3A86FF] to-[#6aa3ff] bg-clip-text text-transparent">
            con precisión y cuidado
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-white/75 text-xl md:text-2xl font-light mb-12 max-w-2xl mx-auto leading-relaxed animate-fadeUp">
          Especialistas en rehabilitación dental en Ciudad de México
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-wrap items-center justify-center gap-4 mb-16 animate-fadeUp">
          <button
            onClick={onOpenModal}
            className="flex items-center gap-2 bg-[#3A86FF] hover:bg-[#1a6aff] text-white px-8 py-4 rounded-full text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer hover:-translate-y-1 shadow-[0_8px_30px_rgba(58,134,255,0.45)] pulse-ring"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-calendar-check-line text-lg" />
            </div>
            Agendar Cita Ahora
          </button>
          <button
            onClick={scrollToServices}
            className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/25 hover:bg-white/20 text-white px-8 py-4 rounded-full text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer hover:-translate-y-1"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-stethoscope-line text-lg" />
            </div>
            Ver Servicios
          </button>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-3 gap-4 max-w-2xl mx-auto animate-fadeUp">
          {[
            { value: '5.0★', label: 'Calificación' },
            { value: '100%', label: 'Pacientes felices' },
            { value: 'CDMX', label: 'Ciudad de México' },
          ].map((stat) => (
            <div key={stat.label} className="glass rounded-2xl px-4 py-4 text-center">
              <div className="text-[#3A86FF] font-bold text-2xl">{stat.value}</div>
              <div className="text-white/60 text-xs mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40 animate-bounce">
        <span className="text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-down-line text-lg" />
        </div>
      </div>
    </section>
  );
}
